'use strict'

module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/~/fs-extra/lib/copy-sync/index.js
// module id = 2058
// module chunks = 0 1